import { EReaction } from 'src/enums'
import { IReactionModel } from 'src/interfaces'

export class ReactionUtils {
  static isEmphasis(item?: Partial<IReactionModel> | null) {
    return [EReaction.SUPER_LIKE, EReaction.SUPER_NOVA].includes(item?.reaction as EReaction)
  }
}
